/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import {getOmegaEvent} from './utils/utils';
import Metrics from '@exc/metrics';
import OverlayTrigger from '@react/react-spectrum/OverlayTrigger';
import React, {useCallback, useRef} from 'react';

let currentVisibleOverlay = null;

export function getCurrentVisibleOverlay() {
  return currentVisibleOverlay;
}

export default function ShellOverlayTrigger({children, element, nested, ...otherProps}) {
  const d = document;
  const ref = useRef(null);
  const closeMenu = useCallback(() => ref.current.hide(), []);
  const metrics = new Metrics('exc.shell.ShellOverlayTrigger');

  function onMenuShow(event, element) {
    if (currentVisibleOverlay && !nested) {
      currentVisibleOverlay.hide();
    }
    currentVisibleOverlay = ref.current;
    d.addEventListener('sandboxClick', closeMenu);
    if (event) {
      let data = {element, event, widget: {name: element, type: 'popover'}};
      if (element === 'help center' || element === 'pulse') {
        data.feature = element;
      }
      metrics.analytics.trackEvent(getOmegaEvent(data));
    }
    if (otherProps.onShow) {
      otherProps.onShow(event);
    }
  }

  function onMenuClose(e) {
    d.removeEventListener('sandboxClick', closeMenu);
    if (otherProps.onHide) {
      otherProps.onHide(e);
    }
  }

  return (
    <OverlayTrigger
      ref={ref}
      trigger="click"
      {...otherProps}
      onHide={(e) => onMenuClose(e)}
      onShow={(e) => onMenuShow(e, element)}>
      {children[0]}
      {React.cloneElement(children[1], {closeMenu})}
    </OverlayTrigger>
  );
}
